module.exports = __webpack_public_path__ + "img/ASFT_visualisoinnit_muokatut-04.94ee5a4d.png";